import { keepPreviousData, skipToken, useQuery } from "@tanstack/react-query";
import {
  fetchSubscription,
  fetchSubscriptionPaymentsPeriods,
  fetchSubscriptions,
  fetchSubscriptionsSchema,
  QueryParams,
} from "./api";

export const useFetchSubscriptionsSchema = () =>
  useQuery({
    queryKey: ["event-logs-subscriptions-schema"],
    queryFn: ({ signal }) => fetchSubscriptionsSchema({ signal }),
  });

export const useFetchSubscriptions = (params?: QueryParams) =>
  useQuery({
    queryKey: ["event-logs-subscriptions", params],
    queryFn: params
      ? ({ signal }) => fetchSubscriptions(params, { signal })
      : skipToken,
    placeholderData: keepPreviousData,
  });

export const useFetchSubscription = (subscriptionId: string) =>
  useQuery({
    enabled: !!subscriptionId,
    queryKey: ["event-logs-subscription", { subscriptionId }],
    queryFn: ({ signal }) => fetchSubscription(subscriptionId, { signal }),
  });

export const useFetchSubscriptionPaymentsPeriods = (params: QueryParams) =>
  useQuery({
    queryKey: ["event-logs-payments-periods", params],
    queryFn: ({ signal }) =>
      fetchSubscriptionPaymentsPeriods(params, { signal }),
    placeholderData: keepPreviousData,
  });
